<template>
  <div class="shelves">
    <img src="../../assets/storeDown.png" alt="" />
    <p class="shelves_name">商品已下架</p>
    <p class="shelves_time">
      <span>{{ times }}</span>
      <span>秒后返回商品列表页</span>
    </p>
    <p class="shelves_click">点击跳转商品列表页</p>
  </div>
</template>

<script>
export default {
  name: "shelves",
  data() {
    return {
      times: 5,
    };
  },
  created() {
    this.getTime(); //只要该页面一渲染创建，就开始倒计时
  },
  methods: {
    getTime() {
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.shelves {
  text-align: center;
  img {
    width: 406px;
  }
  .shelves_name {
    margin-top: 30px;
    font-size: 18px;
    color: rgb(187, 187, 187);
  }
  .shelves_time {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666;
    margin-top: 70px;
    span:nth-of-type(1) {
      margin-right: 5px;
      color: #157efb;
    }
  }
  .shelves_click {
    margin-top: 10px;
    margin-bottom: 80px;
    font-size: 14px;
    color: #157efb;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shelves/shelves.vue